import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { first, map } from 'rxjs/operators';
import { CommunicateService } from './communicate.service';

@Injectable({
  providedIn: 'root',
})
export class DbService {
  private uid: Number = 0;
  constructor(private comu: CommunicateService, private afs: AngularFirestore) {}

  public getInfoService(): Promise<any> {
    const url: string = `info/getInfoService`;
    return this.comu.httpGet(url);
  }

  public getInfoPrivacy(): Promise<any> {
    const url: string = `info/getInfoPrivacy`;
    return this.comu.httpGet(url);
  }

  public setInfoService(content: string): Promise<any> {
    const url: string = `info/setInfoService`;
    return this.comu.httpPost(url, { content });
  }

  public setInfoPrivacy(content: string): Promise<any> {
    const url: string = `info/setInfoPrivacy`;
    return this.comu.httpPost(url, { content });
  }

  public getSaleAllDashboard(startDate: string, endDate: string): Promise<any> {
    const url: string = 'sale/getSaleDashboard';
    return this.comu.httpPost(url, {
      startDate,
      endDate,
    });
  }

  public getSaleAll(startDate: string, endDate: string): Promise<any> {
    const url: string = 'sale/getSaleAll';
    return this.comu.httpPost(url, {
      startDate,
      endDate,
    });
  }

  public getAlarmList(): Promise<any> {
    const url: string = 'manager/getAlarm';
    return this.comu.httpPost(url, {});
  }

  public updateUnreadAlarm(): Promise<any> {
    const url: string = 'manager/updateUnreadAlarm';
    return this.comu.httpPost(url, {});
  }

  public getMangerAlarmCount(): Promise<any> {
    const url: string = 'manager/getMangerAlarmCount';
    return this.comu.httpPost(url, {});
  }

  public signupClub(
    images: Array<string>,
    title: string,
    tel1: string,
    tel2: string,
    tel3: string,
    content: string,
    pooltablebig: string,
    pooltablemiddle: string,
    pooltablepocketball: string,
    starttime: string,
    endtime: string,
    si: string,
    gu: string,
    addressroad: string,
    addressjibun: string,
    addressdetail: string,
    lat: number,
    long: number,
    gameprice: number,
    bigdefaultswitch: boolean,
    bigdefaultprice: number,
    middledefaultswitch: boolean,
    middledefaultprice: number,
    pocketdefaultswitch: boolean,
    pocketdefaultprice: number,
    biguseswitch: boolean,
    biguseprice: number,
    middleuseswitch: boolean,
    middleuseprice: number,
    pocketuseswitch: boolean,
    pocketuseprice: number
  ): Promise<any> {
    const url: string = `club/signupClub`;
    return this.comu.httpPost(url, {
      images,
      title,
      tel1,
      tel2,
      tel3,
      content,
      pooltablebig,
      pooltablemiddle,
      pooltablepocketball,
      starttime,
      endtime,
      si,
      gu,
      addressroad,
      addressjibun,
      addressdetail,
      lat,
      long,
      gameprice,
      bigdefaultswitch,
      bigdefaultprice,
      middledefaultswitch,
      middledefaultprice,
      pocketdefaultswitch,
      pocketdefaultprice,
      biguseswitch,
      biguseprice,
      middleuseswitch,
      middleuseprice,
      pocketuseswitch,
      pocketuseprice,
      userId: this.uid,
    });
  }

  public updateClub(
    clubId: number,
    images: Array<string>,
    title: string,
    tel1: string,
    tel2: string,
    tel3: string,
    content: string,
    pooltablebig: string,
    pooltablemiddle: string,
    pooltablepocketball: string,
    starttime: string,
    endtime: string,
    si: string,
    gu: string,
    addressroad: string,
    addressjibun: string,
    addressdetail: string,
    lat: number,
    long: number,
    gameprice: number,
    bigdefaultswitch: boolean,
    bigdefaultprice: number,
    middledefaultswitch: boolean,
    middledefaultprice: number,
    pocketdefaultswitch: boolean,
    pocketdefaultprice: number,
    biguseswitch: boolean,
    biguseprice: number,
    middleuseswitch: boolean,
    middleuseprice: number,
    pocketuseswitch: boolean,
    pocketuseprice: number,
    activeswitch: boolean
  ): Promise<any> {
    const url: string = `club/updateClub`;
    return this.comu.httpPost(url, {
      clubId,
      images,
      title,
      tel1,
      tel2,
      tel3,
      content,
      pooltablebig,
      pooltablemiddle,
      pooltablepocketball,
      starttime,
      endtime,
      si,
      gu,
      addressroad,
      addressjibun,
      addressdetail,
      lat,
      long,
      gameprice,
      bigdefaultswitch,
      bigdefaultprice,
      middledefaultswitch,
      middledefaultprice,
      pocketdefaultswitch,
      pocketdefaultprice,
      biguseswitch,
      biguseprice,
      middleuseswitch,
      middleuseprice,
      pocketuseswitch,
      pocketuseprice,
      activeswitch,
    });
  }

  public updateClubIP(clubId: number, kioskIP: string, kioskAuth: string): Promise<any> {
    const url: string = `club/updateClubIP`;
    return this.comu.httpPost(url, {
      clubId,
      kioskIP,
      kioskAuth,
    });
  }

  public getClubCount(): Promise<any> {
    const url: string = `club/clubCount`;
    return this.comu.httpGet(url);
  }

  public async getClubs(): Promise<any> {
    const url: string = `club/`;
    const data = await this.comu.httpGet(url);
    data.data.map(async element => {
      const images = await this.getClubImages(element.uid);
      element['images'] = images;
      return element;
    });
    return data;
  }

  public getClubCountOfYear(year): Promise<any> {
    const url: string = `club/clubCountOfYear?year=${year}`;
    return this.comu.httpGet(url);
  }

  public getUserClubList(uid: number): Promise<any> {
    const url: string = `club/getMyClubList?userId=${uid}`;
    return this.comu.httpGet(url);
  }

  public getMyClubList(): Promise<any> {
    const url: string = `club/getMyClubList?userId=${this.uid}`;
    return this.comu.httpGet(url);
  }

  public getClubOtherDetail(clubId: number): Promise<any> {
    const url: string = `club/getClubOtherDetail?clubId=${clubId}`;
    return this.comu.httpGet(url);
  }

  public getClubDetail(): Promise<any> {
    const url: string = `club/clubdetail?uid=${this.uid}`;
    return this.comu.httpGet(url);
  }

  public getUsers(): Promise<any> {
    const url: string = `users/`;
    return this.comu.httpGet(url);
  }

  public getUserCount(): Promise<any> {
    const url: string = `users/userCount`;
    return this.comu.httpGet(url);
  }

  public getUserCountOfYear(year): Promise<any> {
    const url: string = `users/userCountOfYear?year=${year}`;
    return this.comu.httpGet(url);
  }

  public getUserPushId(): Promise<any> {
    const url: string = `users/userPushId`;
    return this.comu.httpGet(url);
  }

  public checkNickname(nickname: string): Promise<any> {
    const url: string = `users/checkNickname?nickname=${nickname}`;
    return this.comu.httpGet(url);
  }

  public updateNicknameProfile(nickname: string, profile: string): Promise<any> {
    const url: string = `users/updateNicknameProfile`;
    return this.comu.httpPost(url, {
      userId: this.uid,
      nickname,
      profile,
    });
  }

  public updateHand(hand: number): Promise<any> {
    const url: string = `users/updateHand`;
    return this.comu.httpPost(url, {
      userId: this.uid,
      hand,
    });
  }

  public deleteFreeboard(boardId: number): Promise<any> {
    const url: string = `board/deleteFreeboard`;
    return this.comu.httpPost(url, {
      boardId,
    });
  }

  public updateComment(commentId: number, comment: string): Promise<any> {
    const url: string = `board/updateComment`;
    return this.comu.httpPost(url, {
      commentId,
      comment,
    });
  }

  public addFreeBoardView(boardId: number): Promise<any> {
    const url: string = `board/addFreeBoardView`;
    return this.comu.httpPost(url, {
      boardId,
    });
  }

  public addComment(postId: number, comment: string, cls: number, groupNum: number): Promise<any> {
    const url: string = `board/addComment`;
    return this.comu.httpPost(url, {
      postId,
      comment,
      userId: this.uid,
      cls,
      groupNum,
    });
  }

  public deleteComment(commentId: number): Promise<any> {
    const url: string = 'board/deleteComment';
    return this.comu.httpPost(url, {
      commentId,
    });
  }

  public getFreeboard(): Promise<any> {
    const url: string = `board/getFreeboard?uid=${this.uid}`;
    return this.comu.httpGet(url);
  }

  public getFreeboardDetail(boardId: number): Promise<any> {
    const url: string = `board/getFreeboardDetail?uid=${boardId}&userId=${this.uid}`;
    return this.comu.httpGet(url);
  }

  public addFreeboard(title: string, content: string, image: string): Promise<any> {
    const url: string = `board/addFreeboard`;
    return this.comu.httpPost(url, {
      image,
      title,
      content,
      userId: this.uid,
    });
  }

  public updateFreeboard(boardId: number, title: string, content: string, image: string): Promise<any> {
    const url: string = `board/updateFreeboard`;
    return this.comu.httpPost(url, {
      boardId,
      image,
      title,
      content,
    });
  }

  public updateUserMainNotice(title: string, noticeId: number): Promise<any> {
    const url: string = `notice/updateUserMainNotice`;
    return this.comu.httpPost(url, {
      title,
      noticeId,
    });
  }

  public addUserMainNotice(title: string, noticeId: number): Promise<any> {
    const url: string = `notice/addUserMainNotice`;
    return this.comu.httpPost(url, {
      title,
      noticeId,
    });
  }

  public getUserMainNotice(): Promise<any> {
    const url: string = `notice/userMainNotice`;
    return this.comu.httpGet(url);
  }

  public updateBanner(uid: number, idx: number, title: string, content: string, image: string, mainimage: string): Promise<any> {
    const url: string = `banner/updateBanner`;
    return this.comu.httpPost(url, {
      uid,
      idx,
      title,
      content,
      mainimage,
      image,
    });
  }

  public addBanner(title: string, content: string, idx: number, datecreated: string, mainimage: string, image: string): Promise<any> {
    const url: string = `banner/addBanner`;
    return this.comu.httpPost(url, {
      title,
      content,
      idx,
      datecreated,
      mainimage,
      image,
    });
  }

  public getBanner(): Promise<any> {
    const url: string = 'banner/getBanner';
    return this.comu.httpGet(url);
  }

  public deleteBanner(bannerId: number): Promise<any> {
    const url: string = `banner/deleteBanner`;
    return this.comu.httpPost(url, {
      bannerId,
    });
  }

  public updateInquiryReply(replyId: number, reply: string): Promise<any> {
    const url: string = `inquiry/updateInquiryReply`;
    return this.comu.httpPost(url, {
      replyId,
      reply,
    });
  }

  public addInquiryReply(inquiryId: number, datecreated: string, reply: string): Promise<any> {
    const url: string = `inquiry/addInquiryReply`;
    return this.comu.httpPost(url, {
      inquiryId,
      datecreated,
      reply,
      replyswitch: true,
    });
  }

  public getInquiryToUserType(type: string): Promise<any> {
    const url: string = `inquiry/getInquiryToUserType?uid=${this.uid}&usertype=${type}`;
    return this.comu.httpGet(url);
  }

  public getInquirys(): Promise<any> {
    const url: string = `inquiry/`;
    return this.comu.httpGet(url);
  }

  public getInquiry(): Promise<any> {
    const url: string = `inquiry/getInquiry?uid=${this.uid}`;
    return this.comu.httpGet(url);
  }

  public getInquiryDetail(inquiryId: number): Promise<any> {
    const url: string = `inquiry/getInquiryDetail?inquiryId=${inquiryId}`;
    return this.comu.httpGet(url);
  }

  public deleteInquiry(inquiryId: string): Promise<any> {
    const url: string = `inquiry/deleteInquiry`;
    return this.comu.httpPost(url, {
      inquiryId,
    });
  }

  public addInquiryUser(category: string, title: string, content: string): Promise<any> {
    const url: string = `inquiry/addInquiryUser`;
    return this.comu.httpPost(url, {
      category,
      title,
      content,
    });
  }

  public addInquiry(category: string, title: string, content: string): Promise<any> {
    const userType: string = localStorage.getItem('userType');
    const url: string = `inquiry/addInquiry`;
    return this.comu.httpPost(url, {
      userType,
      category,
      title,
      content,
      userId: this.uid,
    });
  }

  public getNoticeManagerDetail(noticeId: number): Promise<any> {
    const url: string = `notice/managerNoticeDetail?noticeId=${noticeId}&userId=${this.uid}`;
    return this.comu.httpGet(url);
  }

  public getNoticeUserDetail(noticeId: number): Promise<any> {
    const url: string = `notice/userNoticeDetail?noticeId=${noticeId}&userId=${this.uid}`;
    return this.comu.httpGet(url);
  }

  public getBannerDetail(bannerId: number): Promise<any> {
    const url: string = `banner/bannerDetail?bannerId=${bannerId}&userId=${this.uid}`;
    return this.comu.httpGet(url);
  }

  public addManagerNotice(title: string, content: string, image: string, datecreated: string): Promise<any> {
    const url: string = `notice/addManagerNotice`;
    return this.comu.httpPost(url, {
      datecreated,
      title,
      content,
      image,
    });
  }

  public updateManagerNotice(uid: number, title: string, content: string, image: string): Promise<any> {
    const url: string = `notice/updateManagerNotice`;
    return this.comu.httpPost(url, {
      uid,
      title,
      content,
      image,
    });
  }

  public deleteManagerNotice(uid: number): Promise<any> {
    const url: string = `notice/deleteManagerNotice`;
    return this.comu.httpPost(url, {
      uid,
    });
  }

  public updateManagerNoticeView(noticeId: number): Promise<any> {
    const url: string = `notice/managerAddview`;
    return this.comu.httpPost(url, {
      noticeId,
    });
  }

  public updateNoticeView(noticeId: number): Promise<any> {
    const url: string = `notice/addview`;
    return this.comu.httpPost(url, {
      noticeId,
    });
  }

  public updateBannerView(bannerId: number): Promise<any> {
    const url: string = `banner/addview`;
    return this.comu.httpPost(url, {
      bannerId,
    });
  }

  public getNoticeManager(): Promise<any> {
    const uid: Number = Number(localStorage.getItem('userId'));
    const url: string = `notice/managerNotice?uid=${uid}`;
    return this.comu.httpGet(url);
  }

  public addUserNotice(title: string, content: string, image: string, datecreated: string): Promise<any> {
    const url: string = `notice/addUserNotice`;
    return this.comu.httpPost(url, {
      datecreated,
      title,
      content,
      image,
    });
  }

  public updateUserNotice(uid: number, title: string, content: string, image: string): Promise<any> {
    const url: string = `notice/updateUserNotice`;
    return this.comu.httpPost(url, {
      uid,
      title,
      content,
      image,
    });
  }

  public deleteUserNotice(uid: number): Promise<any> {
    const url: string = `notice/deleteUserNotice`;
    return this.comu.httpPost(url, {
      uid,
    });
  }

  public getAllNoticeUser(): Promise<any> {
    const url: string = `notice/allUserNotice`;
    return this.comu.httpGet(url);
  }

  public getNoticeUser(): Promise<any> {
    const uid: Number = Number(localStorage.getItem('userId'));
    const url: string = `notice/userNotice?uid=${uid}`;
    return this.comu.httpGet(url);
  }

  public updatePhone(prevPhone: string, phone: string): Promise<any> {
    const url: string = 'users/updatePhone';
    const params = {
      prevPhone,
      phone,
    };
    return this.comu.httpPost(url, params);
  }

  public updateOnlyPassword(password: string): Promise<any> {
    const url: string = `users/updateOnlyPassword`;
    const params = {
      userId: this.uid,
      password,
    };
    return this.comu.httpPost(url, params);
  }

  public updatePassword(phone: string, password: string): Promise<any> {
    const url: string = `users/updatePassword`;
    const params = {
      phone,
      password,
    };
    return this.comu.httpPost(url, params);
  }

  public checkPhone(phone: string): Promise<any> {
    const url: string = `users/checkPhone?phone=${phone}`;
    return this.comu.httpGet(url);
  }

  public getSaleClubList(): Promise<any> {
    const url: string = 'sale/getClubList';
    return this.comu.httpPost(url, {});
  }

  public login(phone: string, password: string): Promise<any> {
    const url: string = `users/login`;
    const params = {
      password,
      phone,
    };
    return this.comu.httpPost(url, params);
  }

  public registerUser(hand: number, name: string, nickname: string, password: string, phone: string): Promise<any> {
    const url: string = `users/signup`;
    const params = {
      hand,
      name,
      password,
      phone,
      nickname,
    };
    return this.comu.httpPost(url, params);
  }

  public getClubImages(clubId: number): Promise<any> {
    return new Promise(async resolve => {
      const images = await this.afs
        .doc(`images/${clubId}`)
        .snapshotChanges()
        .pipe(
          map(doc => {
            const data: any = doc.payload.data();
            const id = doc.payload.id;
            if (data && data.images) {
              return data.images;
            } else {
              return [];
            }
          })
        )
        .pipe(first())
        .toPromise();
      resolve(images);
    });
  }

  updateClubImages(clubId: number, images: Array<string>) {
    this.afs.doc(`images/${clubId}`).set({ images: images }, { merge: true });
  }
}
